/**
 * @generated SignedSource<<c684cfce4f67a08be59a0328fc9d2c02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newslettersPageQuery$variables = {
  bundledNewslettersEntityIds?: ReadonlyArray<string> | null | undefined;
};
export type newslettersPageQuery$data = {
  readonly newsletterCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"newsletterCategoryItemSlideshowNewsletterCategory">;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"bundledNewsletterCategoryItemSlideshowNewsletterCategory" | "newsletterColumnistSlideshowAppConfigQuery">;
};
export type newslettersPageQuery = {
  response: newslettersPageQuery$data;
  variables: newslettersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bundledNewslettersEntityIds"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "WEIGHT"
    }
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UrlRedirect",
      "kind": "LinkedField",
      "name": "urlRedirect",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toUrl",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Application",
      "kind": "LinkedField",
      "name": "application",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "fullSectionPath",
          "plural": true,
          "selections": (v6/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentSection",
          "storageKey": null
        }
      ],
      "type": "Section",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flattenTypeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveArticle",
          "kind": "LinkedField",
          "name": "liveArticle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        (v10/*: any*/)
      ],
      "type": "Article",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v10/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaywallType",
              "kind": "LinkedField",
              "name": "paywallTypes",
              "plural": true,
              "selections": [
                (v9/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "newslettersPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NewsletterCategoryConnection",
        "kind": "LinkedField",
        "name": "newsletterCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterCategoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NewsletterCategory",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "newsletterCategoryItemSlideshowNewsletterCategory"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "newsletterCategories(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "bundledNewslettersEntityIds",
            "variableName": "bundledNewslettersEntityIds"
          }
        ],
        "kind": "FragmentSpread",
        "name": "bundledNewsletterCategoryItemSlideshowNewsletterCategory"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "newsletterColumnistSlideshowAppConfigQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "newslettersPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NewsletterCategoryConnection",
        "kind": "LinkedField",
        "name": "newsletterCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterCategoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NewsletterCategory",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "NewsletterConnection",
                    "kind": "LinkedField",
                    "name": "newsletters",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewsletterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Newsletter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NewsletterCategory",
                                "kind": "LinkedField",
                                "name": "newsletterCategories",
                                "plural": true,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "shortDescription",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "longDescription",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfSignedUpUsers",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "newsletters(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "newsletterCategories(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "entityIds",
                "variableName": "bundledNewslettersEntityIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v1/*: any*/)
        ],
        "concreteType": "NewsletterConnection",
        "kind": "LinkedField",
        "name": "newsletters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Newsletter",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v5/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "newslettersColumnist",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_newsletter_columnist"
            }
          }
        ],
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_newsletter_columnist\"})"
      }
    ]
  },
  "params": {
    "cacheID": "2739376e03c764c598347c70f0156d7c",
    "id": null,
    "metadata": {},
    "name": "newslettersPageQuery",
    "operationKind": "query",
    "text": "query newslettersPageQuery(\n  $bundledNewslettersEntityIds: [String!]\n) {\n  newsletterCategories(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        name\n        ...newsletterCategoryItemSlideshowNewsletterCategory\n        id\n      }\n    }\n  }\n  ...bundledNewsletterCategoryItemSlideshowNewsletterCategory_7daME\n  ...newsletterColumnistSlideshowAppConfigQuery\n}\n\nfragment bundledNewsletterCategoryItemSlideshowNewsletterCategory_7daME on Query {\n  newsletters(first: 100, filter: {entityIds: $bundledNewslettersEntityIds}) {\n    edges {\n      node {\n        entityId\n        ...bundledNewsletterItemNewsletter\n        id\n      }\n    }\n  }\n}\n\nfragment bundledNewsletterItemNewsletter on Newsletter {\n  name\n  images {\n    title\n    url\n  }\n  ...signUpButtonNewsletter\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersNewsletterSlideshowItemGetSizeNewsletter on Newsletter {\n  newsletterCategories {\n    entityId\n    id\n  }\n  shortDescription {\n    text\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment mynewsNewsletterItemNewsletter on Newsletter {\n  name\n  images {\n    title\n    url\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  longDescription {\n    text\n  }\n  ...entityLink\n}\n\nfragment newsletterCategoryItemSlideshowNewsletterCategory on NewsletterCategory {\n  entityId\n  name\n  newsletters(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        name\n        ...helpersNewsletterSlideshowItemGetSizeNewsletter\n        ...mynewsNewsletterItemNewsletter\n        ...newsletterItemNewsletter\n        ...plusNewsletterItemNewsletter\n        id\n      }\n    }\n  }\n}\n\nfragment newsletterColumnistSlideshowAppConfigQuery on Query {\n  newslettersColumnist: appConfig(filter: {entityId: \"scmp_pwa_newsletter_columnist\"}) {\n    json\n    id\n  }\n}\n\nfragment newsletterItemNewsletter on Newsletter {\n  name\n  numberOfSignedUpUsers\n  images {\n    title\n    url\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  shortDescription {\n    text\n  }\n  ...entityLink\n  ...signUpButtonNewsletter\n}\n\nfragment plusNewsletterItemNewsletter on Newsletter {\n  name\n  numberOfSignedUpUsers\n  entityId\n  images {\n    title\n    url\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  shortDescription {\n    text\n  }\n  ...entityLink\n  ...signUpButtonNewsletter\n}\n\nfragment signUpButtonNewsletter on Newsletter {\n  entityId\n  name\n  ...entityLink\n}\n"
  }
};
})();

(node as any).hash = "922c1be62d1d2104b4f6fe4326ca6f12";

export default node;
